<template>
    <div class="df fww">
        <div class="task-box" v-for="(item, index) in propsData" :key="index">
            <!-- 答题积分 -->
            <div class="score" v-if="item.tasp_score!=0">{{item.tasp_score}}{{$t('分')}}</div>
            <!-- 通用 -->
             <img class="img" v-if="item.tasp_icon_url" :src="item.tasp_icon_url" alt="">
             <img class="img" v-else :src="require('@/assets/images/challenge/type-'+iconlist[item.dd_question_type]+'.png')" alt="">

            <div class="title">{{ item.tasp_title }}</div>
            <div class="desc">{{ item.tasp_describe }}</div>
            <!-- 每日答题 -->
            <div class="state">
                <!-- 项目证书 -->
                <span class="completed" :class="item.task_status_class" v-for="(item2,index2) in item.task_status_name" :key="item2">{{item2}}</span>
                <div v-if="item.task_count_title">
                    <span class="completed type2">{{item.task_count_title}}</span>
                </div>
            </div>
            <!-- 按钮 -->
            <div class="btn-box mt-8 df aic jcsb">
                <!-- 活动已开始并且未结束 -->
                <template v-if="item.task_status==10">
                    <!-- item.can_submit==20|| -->
                    <el-button class="btn1 df aic" :class="(item.can_submit==20||!islogin())?'':'end'" @click="goAnswer(item)" v-if="getStart(item.tasp_start_time)&&getTime(item.tasp_end_time).type!=4">
                       {{ btntext[item.dd_question_type] }} 
                    </el-button>
                    <el-button class="btn1 end" v-if="getTime(item.tasp_end_time).type==4" @click="finished(item)">{{$t('已结束')}}</el-button>
                    <el-button class="btn1" v-if="!getStart(item.tasp_start_time)" @click="notStarted(item)">{{$t('答题时间')}}</el-button>
                </template>
                <template v-else-if="item.task_status==20">
                    <!-- 每日和每周 -->
                    <template v-if="item.dd_question_type!=10&&item.dd_question_type!=20">
                        <!--dd_question_type==30 大讲堂 报名过后可以点击并且按钮不变灰 -->

                        <el-button class="btn1 df aic" :class="((item.single_submit==20&&item.dd_question_type==30)||item.can_submit==20||!islogin())?'':'end'"
                                   @click="goAnswer(item)"
                                   v-if="getStart(item.tasp_start_time)&&getTime(item.tasp_end_time).type!=4">
                            {{ item.dd_question_type==30?(item.single_submit==20?$t('已申请'):btntext[item.dd_question_type]):btntext[item.dd_question_type] }} 
                        </el-button>
                        <el-button class="btn1 end" v-if="getTime(item.tasp_end_time).type==4" @click="finished(item)">{{$t('已结束')}}</el-button>
                    </template>
                    <button class="btn1 end" v-else>
                        {{$t('已提交')}}
                    </button>
                </template>
                <template v-if="item.can_submit==20 || !islogin()">
                    <!-- 倒计时 -->
                    <template v-if="getStart(item.tasp_start_time)">
                        <!-- 24小时以内 -->
                        <div class="countdown df fn textcolor1" v-if="getTime(item.tasp_end_time).type==1">
                            <img class="dateicon" :src="require('@/assets/images/challenge/dateicon1.png')" alt=""/>
                            <span class="fn">{{$t('倒计时')}}： </span><el-statistic :value="item.tasp_end_time*1000" format="HH:mm:ss" time-indices @finish="finish"></el-statistic>
                        </div>
                        <!-- 一周以内 -->
                        <div class="countdown df fn textcolor2" v-else-if="getTime(item.tasp_end_time).type==2">
                            <img class="dateicon" :src="require('@/assets/images/challenge/dateicon2.png')" alt=""/>
                            <span class="fn">{{$t('自然周倒计时')}}：{{getTime(item.tasp_end_time).date}}{{getTime(item.tasp_end_time).date==1?$t('天'):$t('天s')}}</span>
                        </div>
                        <!-- 一周以后 -->
                        <div class="countdown df fn textcolor3" v-else-if="getTime(item.tasp_end_time).type==3">
                            <img class="dateicon" :src="require('@/assets/images/challenge/dateicon3.png')" alt=""/>
                            <span class="textcolor3">{{$t('倒计时')}}：{{getTime(item.tasp_end_time).date}}{{getTime(item.tasp_end_time).date==1?$t('天'):$t('天s')}}</span>
                        </div>
                        <div class="countdown df fn" v-else-if="getTime(item.tasp_end_time).type==4">
                            <img class="dateicon" :src="require('@/assets/images/challenge/dateicon3.png')" alt=""/>
                            <span class="fn">{{$t('已结束')}}</span>
                        </div>
                    </template>
                    <view class="flex_align" v-else>
                        <img class="dateicon" :src="require('@/assets/images/challenge/dateicon3.png')"></img>
                        <view class="fn">{{$t('未开始')}}</view>
                    </view>
                    
                </template>
            </div>

        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            answerPage:{
                10:'daily',
                20:'weekly',
                30:'lecture',
                40:'circlepart',
                50:'circlelecture',
                60:'technicalarticles',
                70:'projectorder',
                80:'certificate',
            },
            propsData: [],
            // 1每日 2每周 3申请大讲堂 4圈子参会证明 5圈子演讲证明 6技术文章 7下单记录 8证书
            iconlist:{
                10:'1',
                20:'2',
                30:'3',
                40:'4',
                50:'5',
                60:'6',
                70:'7',
                80:'8',
            },
            btntext:{
                10:this.$t('去答题'),
                20:this.$t('去答题'),
                30:this.$t('去申请'),
                40:this.$t('去提交'),
                50:this.$t('去提交'),
                60:this.$t('去发布'),
                70:this.$t('去提交'),
                80:this.$t('去提交'),
            },
            answerPage:{
                10:'answer1',
                20:'answer2',
                30:'answer3',
                40:'answer4',
                50:'answer5',
                60:'answer6',
                70:'answer7',
                80:'answer8',
            },
        }
    },
    // 获取prop数据       
    props: {
        data: {
            type: Array,
            default: () => []
        },
        activeInfo: {
            type: Object,
            default: () => {}
        },
    },
    // 监听prop数据
    watch: {
        data: {
            handler(newVal, oldVal) {
                this.propsData = newVal;
            },
            deep: true,
            immediate: true
        },
    },
    methods:{
        handleAnswer(item){
            let str = '/cn';
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = '/' + Language;   
            }
            this.$router.push(str +  `/challenge/${this.answerPage[item.dd_question_type]}/${item.ta_id}/${item.tas_id}/${item.tasp_id}`)
        },
        //根据获得的时间戳返回判断 时间戳减去当前时间再一天以内返回1，在一个星期以内返回2，再一个星期以外返回3，小于当前时间返回4
        getTime(timestamp) {
            let time = parseInt(Date.now()/1000);
            let day = 24*60*60;
            let week = 7*24*60*60;
            let timeStamp = parseInt(timestamp - time);
            let obj={}
            if (timeStamp < 0) {
                obj={
                    type:4,
                    date:timeStamp
                }
            }else if (timeStamp < day) {
                obj={
                    type:1,
                    date:timeStamp
                }
            }else if (timeStamp < week) {
                obj={
                    type:2,
                    date:parseInt(timeStamp/60/60/24)
                }
            }else{
                obj={
                    type:3,
                    date:parseInt(timeStamp/60/60/24)
                }
            }
            return obj
        },
        // 倒计时结束，刷新当前页面
        finish(){
            this.$router.go(0);
            
        },
        //通过时间戳获取是否开始
        getStart(timestamp) {
            let time = Date.now() / 1000;
            if (time > timestamp) {
                return true;
            }
            return false;
        },
        
        // 去答题
        goAnswer(item){
          let time = Date.now() / 1000;
          if (time >= this.activeInfo.ta_sign_end_timestamp && this.activeInfo.have_sign_up == 20) {
            this.$message({
              message: this.$t('报名已结束1'),
              type: 'error',
            });
            return false;
          }
          this.$emit('goAnswer',item)
        },
        // 点击前往答题
        islogin(){
            let user=JSON.parse(localStorage.getItem('userinfo'))
            if(user.user_id){
                return true
            }else{
                return false
            }
        },
        //活动结束提示
        finished(item){
            // 1每日 2每周 3申请大讲堂 4圈子参会证明 5圈子演讲证明 6技术文章 7下单记录 8证书
            if(item.dd_question_type==10||item.dd_question_type==20){
                this.$alert(this.$t('已过本题目作答有效期，欢迎参加后续题目作答'), '', {
                    confirmButtonText: this.$t('确定')
                });
            }else{
                this.$alert(this.$t('已过本任务提交有效期'), '', {
                    confirmButtonText: this.$t('确定')
                });
            }
        },
        //活动未开始提示
        notStarted(item){
            this.commonpopup=true
            this.commonText="确定"
            // 1每日 2每周 3申请大讲堂 4圈子参会证明 5圈子演讲证明 6技术文章 7下单记录 8证书
            if(item.dd_question_type==10||item.dd_question_type==20){
                this.$alert(this.$t('未到该题目作答日期，请于作答',{ date: this.formatTime(item.tasp_start_time*1000,'YYYY.MM.DD HH:mm') }), '', {
                    confirmButtonText: this.$t('确定')
                });
            }else{
                this.$alert(this.$t('未到该任务提交日期，请于提交',{ date: this.formatTime(item.tasp_start_time*1000,'YYYY.MM.DD HH:mm') }), '', {
                    confirmButtonText: this.$t('确定')
                });
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.score{
    padding: 0 10px;
    height: 32px;
    text-align: center;
    border-radius:0px 16px 0px 16px;
    background: linear-gradient(130.86deg, rgb(255, 234, 235) -26.288%,rgb(252, 232, 217) 96.283%);
    color: rgb(255, 141, 31);
    line-height: 32px;
    font-size: 16px;
    position: absolute;
    right: 0;
    top: 0;
}
.btn-box {
    .btn1 {
        min-width: 68px;
        height: 32px;
        border: 0.5px solid rgb(25, 25, 25);
        border-radius: 18px;
        padding: 0 16px;
        font-size: 12px;
        color: rgb(25, 25, 25);
        &:hover {
            border: 0.5px solid #b7251e;
            color: #b7251e;
            background-color: #FFFFFF;
        }
    }
    .btn1.end{
        background: rgb(243, 243, 243);
        color: rgb(174, 174, 174);
        border: none;
    }

    .iconfont{
        font-size: 24px;
        margin-right: 8px;
    }

    ::v-deep() { 
        .countdown,
        .el-statistic .con .number {
            color: rgb(229, 69, 69);
            font-size: 14px;
            line-height: 22px;
            display: flex;
            align-items: center;
        }
        .textcolor1{
            color: #E54545;
        }
        .textcolor2{
            color: #EC6F1A;
        }
        .textcolor3{
            color: #1C94A4;
        }
    }
    .dateicon{
        width: 24px;
        height: 24px;
        margin-right: 8px;
    }
}

.task-box {
    width: calc(33.33% - 16px);
    min-height: 342px;
    border-radius: 20px;
    background: rgb(255, 255, 255);
    transform: all .36s;
    margin-right: 24px;
    margin-top: 24px;
    padding: 32px;
    position: relative;
    .img {
        max-width: 80px;
    }

    .state {
        margin-top: 16px;

        .completed {
            display: inline-block;
            border-radius: 4px;
            font-size: 12px;
            line-height: 24px;
            padding: 0 8px;
            margin-right: 8px;
            margin-bottom: 8px;
            &.type1 {
                background: rgb(245, 246, 248);
                color: rgb(119, 119, 119);
            }
            &.type2 {
                color: rgb(98, 180, 46);
                background: rgba(100, 187, 92, 0.16);
            }

        }
    }

    .title {
        color: rgb(25, 25, 25);
        font-family: "MicrosoftYaHeiSemibold";
        font-size: 20px;
        line-height: 30px;
        margin-top: 24px;
    }

    .desc {
        color: rgb(112, 112, 112);
        font-size: 16px;
        line-height: 24px;
        margin-top: 8px;
        min-height: 48px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    &:nth-child(3n) {
        margin-right: 0;
    }

    &:hover {
        box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.08);
    }
}
</style>